import type {
  IntencaoDeclarada,
  MotivoBloqueioCredito,
  OrigemAbaCredito,
  VinculoDeclarado,
} from '@/features/credito/types/qualificacao';
import { MOTIVOS_BLOQUEIO_CREDITO } from '@/features/credito/types/qualificacao';

export type EtapaQualificacao = 'vinculo' | 'intencao';

export function avaliarVinculo(vinculo: VinculoDeclarado): MotivoBloqueioCredito | null {
  return vinculo === 'nao' ? 'sem_vinculo_clt' : null;
}

export function avaliarIntencao(intencao: IntencaoDeclarada): MotivoBloqueioCredito | null {
  return intencao === 'olhando' ? 'so_olhando' : null;
}

export function origemAbaDaQuery(valor: unknown): OrigemAbaCredito {
  return valor === 'emprestimos' ? 'emprestimos' : 'dividas';
}

export function motivoBloqueioDaQuery(valor: unknown): MotivoBloqueioCredito | null {
  return MOTIVOS_BLOQUEIO_CREDITO.find(motivo => motivo === valor) ?? null;
}

/** Primeira pergunta ainda sem resposta que libera a jornada; `null` quando a pessoa já se qualificou. */
export function etapaPendenteDaQualificacao(respostas: {
  vinculo: VinculoDeclarado | null;
  intencao: IntencaoDeclarada | null;
}): EtapaQualificacao | null {
  if (!respostas.vinculo || avaliarVinculo(respostas.vinculo)) {
    return 'vinculo';
  }
  if (respostas.intencao !== 'contratar') {
    return 'intencao';
  }
  return null;
}
